var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3H20V18.492C20 20.5484 17.6555 21.7254 16.0064 20.4968L15.3017 19.9718C15.124 19.8394 14.8803 19.8398 14.703 19.9727L14.4 20.2C12.9778 21.2667 11.0222 21.2667 9.6 20.2L9.297 19.9727C9.11969 19.8398 8.87601 19.8394 8.69828 19.9718L7.99358 20.4968C6.34449 21.7254 4 20.5484 4 18.492V3ZM6 5V18.492C6 18.9033 6.4689 19.1387 6.79872 18.8929L7.50342 18.3679C8.39206 17.7059 9.61048 17.7079 10.497 18.3727L10.8 18.6C11.5111 19.1333 12.4889 19.1333 13.2 18.6L13.503 18.3727C14.3895 17.7079 15.6079 17.7059 16.4966 18.3679L17.2013 18.893C17.5311 19.1387 18 18.9033 18 18.492V5H6Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10H11C11.5523 10 12 9.55228 12 9C12 8.44772 11.5523 8 11 8H9ZM15 8C14.4477 8 14 8.44772 14 9C14 9.55228 14.4477 10 15 10C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8ZM8 13C8 12.4477 8.44772 12 9 12H11C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14H9C8.44772 14 8 13.5523 8 13ZM15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12Z",
    fill: "#6B92FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4C21 4.55228 20.5523 5 20 5H4C3.44772 5 3 4.55228 3 4Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.b3949077.svg";
export { ForwardRef as ReactComponent };